import {
  polandCountryConstant,
  HungaryCountryConstant,
  UkraineCountryConstant,
  SouthAfricaCountryConstant,
  BulgariaCountryConstant,
  RomaniaCountryConstant,
  GermanyCountryConstant,
  BrazilCountryConstant,
  UKCountryConstant,
  FranceCountryConstant,
  SerbiaCountryConstant,
  RussiaCountryConstant,
  BelgiumCountryConstant,
  NetherlandsCountryConstant,
  SpainCountryConstant,
  KazakhstanCountryConstant,
  BelarusCountryConstant,
} from 'utils/constants/CountryData';

export const isPoland = (country: string | undefined): boolean => {
  if (
    country?.toLocaleLowerCase() === polandCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === polandCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === polandCountryConstant.id.toLocaleLowerCase()
  ) {
    return true;
  } else {
    return false;
  }
};

export const isHungary = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === HungaryCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === HungaryCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === HungaryCountryConstant.id.toLocaleLowerCase()
  );
};

export const isUkraine = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === UkraineCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === UkraineCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === UkraineCountryConstant.id.toLocaleLowerCase()
  );
};

export const isSouthAfrica = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === SouthAfricaCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === SouthAfricaCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === SouthAfricaCountryConstant.id.toLocaleLowerCase()
  );
};
export const isBulgaria = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === BulgariaCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === BulgariaCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === BulgariaCountryConstant.id.toLocaleLowerCase()
  );
};

export const isGermany = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === GermanyCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === GermanyCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === GermanyCountryConstant.id.toLocaleLowerCase()
  );
};

export const isRomania = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === RomaniaCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === RomaniaCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === RomaniaCountryConstant.id.toLocaleLowerCase()
  );
};

export const isBrazil = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === BrazilCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === BrazilCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === BrazilCountryConstant.id.toLocaleLowerCase()
  );
};
export const isUK = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === UKCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === UKCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === UKCountryConstant.id.toLocaleLowerCase()
  );
};

export const isFrance = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === FranceCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === FranceCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === FranceCountryConstant.id.toLocaleLowerCase()
  );
};

export const isSerbia = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === SerbiaCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === SerbiaCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === SerbiaCountryConstant.id.toLocaleLowerCase()
  );
};

export const isRussia = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === RussiaCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === RussiaCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === RussiaCountryConstant.id.toLocaleLowerCase()
  );
};

export const isBelgium = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === BelgiumCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === BelgiumCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === BelgiumCountryConstant.id.toLocaleLowerCase()
  );
};
export const isSpain = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === SpainCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === SpainCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === SpainCountryConstant.id.toLocaleLowerCase()
  );
};
export const isNetherlands = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === NetherlandsCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === NetherlandsCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === NetherlandsCountryConstant.id.toLocaleLowerCase()
  );
};
export const isKazakhstan = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === KazakhstanCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === KazakhstanCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === KazakhstanCountryConstant.id.toLocaleLowerCase()
  );
};
export const isBelarus = (country: string | undefined): boolean => {
  return (
    country?.toLocaleLowerCase() === BelarusCountryConstant.label.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === BelarusCountryConstant.value.toLocaleLowerCase() ||
    country?.toLocaleLowerCase() === BelarusCountryConstant.id.toLocaleLowerCase()
  );
};
